"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPremiumCoverDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const opportunity_cover_entity_1 = require("./opportunity-cover.entity");
let OpportunityPremiumCoverDetail = class OpportunityPremiumCoverDetail {
    constructor(opportunityId, coverMapId, policyTypeLid, coverName, coverResponse, createdBy, updatedBy) {
        this.opportunityId = opportunityId;
        this.coverMapId = coverMapId;
        this.policyTypeLid = policyTypeLid;
        this.coverName = coverName;
        this.coverResponse = coverResponse;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.OpportunityPremiumCoverDetail = OpportunityPremiumCoverDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCoverDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCoverDetail.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_map_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCoverDetail.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCoverDetail.prototype, "policyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPremiumCoverDetail.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_response", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityPremiumCoverDetail.prototype, "coverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityPremiumCoverDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityPremiumCoverDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCoverDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCoverDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPremiumCoverDetail.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_cover_entity_1.OpportunityCoverMap, (coverMap) => coverMap.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "cover_map_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPremiumCoverDetail.prototype, "coverMap", void 0);
exports.OpportunityPremiumCoverDetail = OpportunityPremiumCoverDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_premium_cover_detail"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, String, String, Number, Number])
], OpportunityPremiumCoverDetail);
